export function isUserModerator(user) {
    return user.type === 'moderator'
}

export function isUserAdmin(user) {
    return user.email === "admin@idea-box.com"
}

export function createDisplayName(user) {
    if (!user) return 'Unknown'

    let firstPart
    if (!user.firstName && !user.lastName) firstPart = user.email
    else {
        if (user.firstName) firstPart = user.firstName
        if (user.lastName) firstPart += ' ' + user.lastName
    }

    // TODO add department?
    return firstPart
}
